export default {
    namespaced: true,
    state: {
        config: []
    },
    getters: {
        config: state => state.config,
        configBeforeAddress: state => state.config.filter(item => "beforeAddress" === item.container),
        configAfterAddress: state => state.config.filter(item => "afterAddress" === item.container)
    },
    mutations: {
        setConfig: (state, config) => state.config = config
    },
    actions: {
        setConfig(context, config) {

            context.commit("setConfig", config);
        },
        clear(context) {

            context.commit("setConfig", []);
        }
    }
}